
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"x","transform":"translate(-670.771 -382.398)"}},[_c('circle',{attrs:{"id":"Ellipse_301","data-name":"Ellipse 301","cx":"6.4","cy":"6.4","r":"6.4","transform":"translate(671.371 382.998)","fill":"none","stroke":"#e95d65","stroke-width":"1.2"}}),_c('path',{attrs:{"id":"Path_19470","data-name":"Path 19470","d":"M678.831 389.4l1.47-1.469a.75.75 0 00-1.061-1.061l-1.469 1.47-1.47-1.47a.75.75 0 00-1.061 1.061l1.47 1.469-1.47 1.47a.75.75 0 001.061 1.061l1.47-1.47 1.469 1.47a.75.75 0 001.061-1.061z","fill":"#e95d65"}})])])
          )
        }
      }
    